import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface QueuedNotification {
  recipientId: string;
  senderId: string;
  businessId: string;
  /** NotificationType raw value shared with the apps, e.g. `check_in`. */
  type: string;
  title: string;
  body: string;
  data: Record<string, string>;
}

/**
 * Queue push notifications for the server to deliver (CROSS_PLATFORM_CONTRACTS.md §2).
 * The `onNotificationCreated` function checks each recipient's preferences and
 * sends; clients never send pushes themselves.
 *
 * Best effort: the action that triggered the notification has already been saved,
 * so a refused or failed queue write is logged and never surfaced as a failure.
 * Returns how many were queued.
 */
export async function queueNotifications(notifications: QueuedNotification[]): Promise<number> {
  const results = await Promise.allSettled(
    notifications.map((n) =>
      addDoc(collection(db, 'notifications'), {
        ...n,
        createdAt: serverTimestamp(),
        status: 'pending',
      })
    )
  );
  const failed = results.filter((r) => r.status === 'rejected');
  if (failed.length > 0) {
    console.warn(`Could not queue ${failed.length} of ${results.length} notifications`, failed);
  }
  return results.length - failed.length;
}
